// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"457":"64113bad","851":"c4c3715f"}[chunkId] + ".chunk.js";
};